import {all, call, cancelled, put, select, takeEvery} from "redux-saga/effects";
import * as rootSelectors from "../../../selectors/root";
import * as eventRoutines from "../eventRoutines";
import * as userRoutines from "../../../sagas/routines/userRoutines";

import api from "../../../services/api";

export function* syncGuestListWithActiveUsersSaga(action) {
    try {
        const eventId = yield select(rootSelectors.selectActiveEventId);

        const meta =  yield call(fetchMetaInfoForInviteesForEvent, eventId)
        yield call(bgFetchInviteesSync, meta.totalPages, meta.itemsPerPage)

    } catch (error) {
        yield put(eventRoutines.syncGuestListWithActiveUsers.failure(error));
    }
}



//TODO determine way to get cancel to play nicely with api calls using our sdk
function* bgFetchInviteesSync(totalPages, itemsPerPage) {
    try {
        yield all([...Array(totalPages)].map((val, idx) => {
            let page = idx + 1;
            //Retrieve the batch of invitees for each page, with consistant itemsPerPage from above
            return call(processInviteeBatchSaga, {
                itemsPerPage,
                page,
            });
        }))
        yield put(eventRoutines.bgFetchInviteesSync.success())
        yield put(userRoutines.updateActiveUsers()) //Populates key/value pairs in FB
        yield put(userRoutines.updateUserInfo())

        yield put (eventRoutines.syncGuestListWithActiveUsers.success())
    } finally {
        if (yield cancelled()) {
        }
    }
}

function* fetchMetaInfoForInviteesForEvent(eventId){
    //Default values
    let itemsPerPage;
    let totalPages;


        itemsPerPage = 50;
        totalPages = 1;
        //Obtain meta information about the invitee data for the event (page, itemsPerPage)
        let res = yield call(api.fetchInviteesBatchForEvent, eventId, 1, 50);
        itemsPerPage = res.data.meta.itemsPerPage;
        totalPages = res.data.meta.totalPages;


    return {totalPages, itemsPerPage}
}

function* processInviteeBatchSaga(payload) {
    const { itemsPerPage, page } = payload;
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {
        //Fetch specific batch/page of invitees
            let batch = yield call(api.fetchInviteesBatchForEvent, activeEvent, page, itemsPerPage);
            yield put(eventRoutines.fetchInviteesBatchForEvent.success(batch.data.data));

    } catch (error) {
        yield put(eventRoutines.fetchInviteesBatchForEvent.error(error));
    }
}

export default function* rootSaga() {
    yield takeEvery(eventRoutines.syncGuestListWithActiveUsers, syncGuestListWithActiveUsersSaga);

}